import { MaybeString } from './types/types'

export const capitalizeName = (name: MaybeString) => {
    const nameToLowerCase = name ? name.toLowerCase() : ''
    const capitalizedNames = nameToLowerCase.replace(/(?:^|\s|-|´)\S/g, (a) => {
       return a.toUpperCase()
    })

    return capitalizedNames
}
